import { type FC } from "react";
import { Filter } from "@/partner/shared/components/Filter";

// Без `title`: заголовок страницы стоит над вкладками (Chat.tsx), иначе он
// дублировался бы в карточке фильтра и пропадал бы на вкладке банов.
export const ChatMessagesFilter: FC = () => {
  return <Filter fields={{ search: true, contentIds: true }} />;
};
